<template>
  <div id="print-header-layout">
    <div style="float: left">
      <img
        style="padding: 2rem;"
        src="https://via.placeholder.com/500x250.png"
        :alt="hospitalProfile.name"
      >
    </div>
    <div>
      <h2 style="text-align: left; ">
        {{ corporation.name }}
      </h2>
    </div>
    <div>
      <h2 style="text-align: left; ">
        {{ corporation.address }}
      </h2>
    </div>
    <div>
      <h2 style="text-align: left; ">
        โทรศัพท์ {{ corporation.phone }}
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrintLayout",
  filters: {
    sexGenerate(val) {
      switch (val) {
        case 1:
          return 'Male'
        case 2:
          return 'Female'
        case 3:
          return 'Unknown'
      }
    }
  },
  props: {
    hospitalProfile: {
      type: Object,
      required: true
    },
    corporation: {
      type: Object,
      required: true
    },
    pet: {
      type: Object,
      required: true
    }
  }
}
</script>

